import { MuiThemeProvider } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import './assets/css/index.css';
import { AppThemes } from './common/theme/Theme';
import NotFoundScreen from './screen/etc/NotFoundScreen';
import { AccountListScreen } from './screen/login/AccountListScreen';
import { ConsentScreen } from './screen/login/ConsentScreen';
import { DecisionScreen } from './screen/login/DecisionScreen';
import LoginScreen from './screen/login/LoginScreen';
import { MobileNumberScreen } from './screen/login/MobileNumberScreen';
import { NationalIdScreen } from './screen/login/NationalIdScreen';
import { OTPScreen } from './screen/login/OTPScreen';
import { SuccessScreen } from './screen/login/SuccessScreen';
import { ManageAccountScreen } from './screen/main/ManageAccountScreen';
import { MobileNumberForManageScreen } from './screen/main/MobileNumberForManageScreen';
import { OTPForManageScreen } from './screen/main/OTPForManageScreen';
import { TermAndCondScreen } from './screen/main/TermAndCondScreen';
import { ChooseAmount } from './screen/payment/ChooseAmount';
import { ChooseChannel } from './screen/payment/ChooseChannel';
import { OtherBank } from './screen/payment/OtherBank';
import { QrBarcode } from './screen/payment/QrBarcode';
import StoreContext from './service/storeContext';
import { persistor } from './store';
import History from './store/History';
import { Path } from './utils/Constant';
import { getVersion } from './utils/StringManager';
const history = History;

// const {store, persistor} = rootReducer()

export function Routes() {
  const [global, setGlobal] = useState({ loading: false });

  useEffect(() => {
    console.log(getVersion());
  }, []);

  return (
    <MuiThemeProvider theme={AppThemes}>
      <PersistGate persistor={persistor}>
        <StoreContext.Provider value={{ global, setGlobal }}>
          <div
            style={{
              width: '100%',
              verticalAlign: 'middle',
              display: 'inline-block',
              boxShadow: 'none',
            }}
          >
            <Switch>
              <Route exact path={Path.index} component={LoginScreen} />
              <Route exact path={Path.landing} component={LoginScreen} />
              <Route exact path={Path.login} component={LoginScreen} />
              <Route exact path={Path.nationalId} component={NationalIdScreen} />
              <Route exact path={Path.consent} component={ConsentScreen} />
              <Route exact path={Path.tNc_view} component={TermAndCondScreen} />
              <Route exact path={Path.mobile} component={MobileNumberScreen} />
              <Route exact path={Path.otp} component={OTPScreen} />
              <Route exact path={Path.decision} component={DecisionScreen} />
              <Route exact path={Path.account} component={AccountListScreen} />
              <Route exact path={Path.success} component={SuccessScreen} />

              <Route exact path={Path.mng_acc} component={MobileNumberForManageScreen} />
              <Route exact path={Path.mng_vrf} component={OTPForManageScreen} />
              <Route exact path={Path.mng_chg} component={ManageAccountScreen} />

              <Route exact path={Path.pay_channel} component={ChooseChannel} />
              <Route exact path={Path.pay_amount} component={ChooseAmount} />
              <Route exact path={Path.qrcode} component={QrBarcode} />
              <Route exact path={Path.other_bank} component={OtherBank} />
              <Route exact path={Path.expired} component={NotFoundScreen} />
              <Route component={NotFoundScreen} />
            </Switch>
          </div>
        </StoreContext.Provider>
      </PersistGate>
    </MuiThemeProvider>
  );
}

export const InsuranceApp = () => (
  <React.StrictMode>
    <Router history={history}>
      <Routes />
    </Router>
  </React.StrictMode>
);
